import { Form as AntForm } from 'antd';
import { FormProps as AntFormProps } from 'antd/lib/form';

type FormProps = {
  // TODO
};

const Form = (props: FormProps & AntFormProps) => {
  const { className } = props;
  const classNames = [className, 'form'];
  return <AntForm {...props} className={classNames.filterNotNull().join(' ')} />;
};

Form.defaultProps = {
  // TODO
};

// TODO
Form.useForm = AntForm.useForm;

export default Form;
